import { render } from "./OperateBtn.vue?vue&type=template&id=98020d28&scoped=true"
import script from "./OperateBtn.vue?vue&type=script&lang=js"
export * from "./OperateBtn.vue?vue&type=script&lang=js"

import "./OperateBtn.vue?vue&type=style&index=0&id=98020d28&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98020d28"]])

export default __exports__